import { useState } from "react";
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { Paper, Grid, Autocomplete, CircularProgress, TextField, } from "@mui/material";
import Header from "./Header";
import LessorFilter from "./LessorFilter";
import { EndDateFilter, StartDateFilter } from "./DateFilter";
import { getPaymentReceivedReportApi } from "../apiService";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import { isValidYearRange } from "../../../utils/helper";
import { trackActivity } from "../../../utils/mixpanel";

const PaymentsReceivedReport = ({pltConstants,dropDownLoader}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({});
  const [error, setError] = useState({});
  const onFieldChange = (key, value) => {
    setReportData((prev) => {
      const updatedData = { ...prev, [key]: value };
      if (key === "start_date" && !value) { updatedData.end_date = null; }
      return updatedData;
    });
  };    
  const onFocusChange = (keyParam) => { setError(prev => ({ ...prev, [keyParam]: '' })) }
  const onExportReport = (extention) => {
    let validationInputs = {};
    validationInputs = {
      start_date: !reportData?.start_date ? "Please select Start Date" : !isValidYearRange(reportData?.start_date) ? "Year must be between 1900 and 2100." : "",
      end_date: !reportData?.end_date ? "Please select End Date" : moment(reportData.end_date).isBefore(moment(reportData.start_date)) ? "End date must be after Start Date" : !isValidYearRange(reportData?.end_date) ? "Year must be between 1900 and 2100." : "",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      const query = {
        file_type: extention, statement_type: "cashflow", start_date: reportData?.start_date, end_date: reportData?.end_date,
        ...(reportData?.lessor_name_id?.length > 0) && { lessor_name_id: reportData?.lessor_name_id?.map(item => item.id).join(",") ?? "" },
        ...(reportData?.lessee_ids?.length > 0) && { lessee_ids: reportData?.lessee_ids?.map(item => item.id).join(",") ?? "" },
      };
      setLoading(true)
      globalGetService(getPaymentReceivedReportApi(query))
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Payments Received Report`, success_msg: response?.data?.message, payload: query, response: response?.data })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Payments Received Report`, error_msg: response?.data?.message, payload: query, response: response?.data })
          }
        });
    } else {
      setError(validationInputs)
      trackActivity('Item Export', { page_title: `Payments Received Report`, error_msg: validationInputs })
    }
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container   spacing={1} alignItems="center"  className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Payments Received Report" description="Invoice Report; Paid Invoices Report." />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }}  sx={{ display: "flex", justifyContent: "flex-end",alignItems: "flex-start"  }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }, { title: 'CSV', extension: 'csv' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 6, xs: 12 }} >
            <StartDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} isFutureDisabled={true} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <EndDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} disabled={!reportData?.start_date} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }} >
            <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <p className='lessor-select'><span onClick={() => setReportData({ ...reportData, lessee_ids: pltConstants?.lessee })}>Select All Lessee</span>{reportData?.lessee_ids?.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setReportData({ ...reportData, lessee_ids: [] }); }} >Remove All Lessee</span> : null}</p>
            <Autocomplete
              disablePortal
              options={pltConstants?.lessee || []}
              multiple={true}
              value={reportData?.lessee_ids || []}
              getOptionLabel={(option) => option.name || ""}
              onChange={(e, newValue) => onFieldChange('lessee_ids', newValue)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Lessee"
                  margin='normal'
                  size='small'
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {dropDownLoader?.lessee && (
                            <CircularProgress color="inherit" size={18} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    },
                    inputLabel: { shrink: true },
                  }}
                  placeholder="Select Lessee(s)"
                />
              )}
            />
          </Grid>
          
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default PaymentsReceivedReport